import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类浏览', path: '/category/rexue' },
  { name: '关于我们', path: '/about' }
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫大全
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                    location.pathname === link.path
                      ? 'text-primary-500'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-48 px-4 py-2 text-sm rounded-full border border-background-300/60 bg-background-100 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/20 transition-all"
                />
                <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl text-foreground-950 ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70">
            <div className="px-4 py-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-primary-500'
                      : 'text-foreground-700'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="relative mt-2">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full px-4 py-2 text-sm rounded-full border border-background-300/60 bg-background-100 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-all"
                />
                <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
      <div className="h-16"></div>
    </>
  );
}